export var NebulaIconNames;
(function (NebulaIconNames) {
    NebulaIconNames["ADULTS"] = "adults";
    NebulaIconNames["AMENITIES"] = "amenities";
    NebulaIconNames["BED"] = "bed";
    NebulaIconNames["BEDS"] = "beds";
    NebulaIconNames["CALENDAR"] = "calendar";
    NebulaIconNames["EMAIL"] = "email";
    NebulaIconNames["GUESTS"] = "guests";
    NebulaIconNames["KIDS"] = "kids";
    NebulaIconNames["PHONE"] = "phone";
    NebulaIconNames["PROPERTY"] = "property";
    NebulaIconNames["SLIDERS"] = "sliders";
    NebulaIconNames["TAG"] = "tag";
    NebulaIconNames["USER"] = "user";
})(NebulaIconNames || (NebulaIconNames = {}));
